<template>
    <z-basePage :title="'预算设置'" :pop="true">
        <budgetAuto></budgetAuto>
    </z-basePage>
</template>

<script>
    import budgetAuto from 'src/views/backEndStage/finance/budget-auto.vue'

    export default {
        components:{
            budgetAuto,
        },
        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-budget-auto',path:to.path});
			next(res);
		},
    }
</script>

<style lang="less">

</style>







// WEBPACK FOOTER //
// page-budget-set.vue?6e847e86